export const PERMISOS = {
    MIPRES: {
        VER_GESTION: "MIPRES.VER_GESTION",
        ACTUALIZACION_MASIVA_SINCRONIZACION_BOT:
            "MIPRES.ACTUALIZACION_MASIVA_SINCRONIZACION_BOT",
        CONCILIACION_EXTERNA: "MIPRES.CONCILIACION_EXTERNA",
    },
};
